"use client";
import { jsx as se } from "react/jsx-runtime";
import { useState as L, useLayoutEffect as ie, useEffect as Z, useMemo as R, useRef as P, useCallback as B, memo as ae, useImperativeHandle as fe, createElement as Q } from "react";
function be(e) {
  let t = e;
  for (; t; ) {
    if (t.dir)
      return t.dir === "rtl";
    t = t.parentElement;
  }
  return !1;
}
function Ie(e, t) {
  const [s, r] = L(t === "rtl");
  return ie(() => {
    e && (t || r(be(e)));
  }, [t, e]), s;
}
const J = typeof window < "u" ? ie : Z;
function ce(e) {
  if (e !== void 0)
    switch (typeof e) {
      case "number":
        return e;
      case "string": {
        if (e.endsWith("px"))
          return parseFloat(e);
        break;
      }
    }
}
function we({
  box: e,
  defaultHeight: t,
  defaultWidth: s,
  disabled: r,
  element: n,
  mode: i,
  style: l
}) {
  const { styleHeight: f, styleWidth: a } = R(
    () => ({
      styleHeight: ce(l?.height),
      styleWidth: ce(l?.width)
    }),
    [l?.height, l?.width]
  ), [o, d] = L({
    height: t,
    width: s
  }), c = r || i === "only-height" && f !== void 0 || i === "only-width" && a !== void 0 || f !== void 0 && a !== void 0;
  return J(() => {
    if (n === null || c)
      return;
    const g = new ResizeObserver((x) => {
      for (const I of x) {
        const { contentRect: h, target: z } = I;
        n === z && d((u) => u.height === h.height && u.width === h.width ? u : {
          height: h.height,
          width: h.width
        });
      }
    });
    return g.observe(n, { box: e }), () => {
      g?.unobserve(n);
    };
  }, [e, c, n, f, a]), R(
    () => ({
      height: f ?? o.height,
      width: a ?? o.width
    }),
    [o, f, a]
  );
}
function de(e) {
  const t = P(() => {
    throw new Error("Cannot call an event handler while rendering.");
  });
  return J(() => {
    t.current = e;
  }, [e]), B((...s) => t.current?.(...s), [t]);
}
let F = null;
function me(e = !1) {
  if (F === null || e) {
    const t = document.createElement("div"), s = t.style;
    s.width = "50px", s.height = "50px", s.overflow = "scroll", s.direction = "rtl";
    const r = document.createElement("div"), n = r.style;
    return n.width = "100px", n.height = "100px", t.appendChild(r), document.body.appendChild(t), t.scrollLeft > 0 ? F = "positive-descending" : (t.scrollLeft = 1, t.scrollLeft === 0 ? F = "negative" : F = "positive-ascending"), document.body.removeChild(t), F;
  }
  return F;
}
function C({
  containerElement: e,
  direction: t,
  isRtl: s,
  scrollOffset: r
}) {
  if (t === "horizontal" && s)
    switch (me()) {
      case "negative":
        return -r;
      case "positive-descending": {
        if (e) {
          const { clientWidth: n, scrollLeft: i, scrollWidth: l } = e;
          return l - n - i;
        }
        break;
      }
    }
  return r;
}
function k(e, t = "Assertion error") {
  if (!e)
    throw console.error(t), Error(t);
}
function X(e, t) {
  if (e === t)
    return !0;
  if (!!e != !!t || (k(e !== void 0), k(t !== void 0), Object.keys(e).length !== Object.keys(t).length))
    return !1;
  for (const s in e)
    if (!Object.is(t[s], e[s]))
      return !1;
  return !0;
}
function ue({
  cachedBounds: e,
  itemCount: t,
  itemSize: s
}) {
  if (t === 0)
    return 0;
  if (typeof s == "number")
    return t * s;
  {
    const r = e.get(
      e.size === 0 ? 0 : e.size - 1
    );
    k(r !== void 0, "Unexpected bounds cache miss");
    const n = (r.scrollOffset + r.size) / e.size;
    return t * n;
  }
}
function Oe({
  align: e,
  cachedBounds: t,
  index: s,
  itemCount: r,
  itemSize: n,
  containerScrollOffset: i,
  containerSize: l
}) {
  if (s < 0 || s >= r)
    throw RangeError(`Invalid index specified: ${s}`, {
      cause: `Index ${s} is not within the range of 0 - ${r - 1}`
    });
  const f = ue({
    cachedBounds: t,
    itemCount: r,
    itemSize: n
  }), a = t.get(s), o = Math.max(
    0,
    Math.min(f - l, a.scrollOffset)
  ), d = Math.max(
    0,
    a.scrollOffset - l + a.size
  );
  switch (e === "smart" && (i >= d && i <= o ? e = "auto" : e = "center"), e) {
    case "start":
      return o;
    case "end":
      return d;
    case "center":
      return a.scrollOffset <= l / 2 ? 0 : a.scrollOffset + a.size / 2 >= f - l / 2 ? f - l : a.scrollOffset + a.size / 2 - l / 2;
    case "auto":
    default:
      return i >= d && i <= o ? i : i < d ? d : o;
  }
}
function ee({
  cachedBounds: e,
  containerScrollOffset: t,
  containerSize: s,
  itemCount: r,
  overscanCount: n
}) {
  const i = r - 1;
  let l = 0, f = -1, a = 0, o = -1, d = 0;
  for (; d < i; ) {
    const c = e.get(d);
    if (c.scrollOffset + c.size > t)
      break;
    d++;
  }
  for (l = d, a = Math.max(0, l - n); d < i; ) {
    const c = e.get(d);
    if (c.scrollOffset + c.size >= t + s)
      break;
    d++;
  }
  return f = Math.min(i, d), o = Math.min(r - 1, f + n), l < 0 && (l = 0, f = -1, a = 0, o = -1), {
    startIndexVisible: l,
    stopIndexVisible: f,
    startIndexOverscan: a,
    stopIndexOverscan: o
  };
}
function ye({
  itemCount: e,
  itemProps: t,
  itemSize: s
}) {
  const r = /* @__PURE__ */ new Map();
  return {
    get(n) {
      for (k(n < e, `Invalid index ${n}`); r.size - 1 < n; ) {
        const l = r.size;
        let f;
        switch (typeof s) {
          case "function": {
            f = s(l, t);
            break;
          }
          case "number": {
            f = s;
            break;
          }
        }
        if (l === 0)
          r.set(l, {
            size: f,
            scrollOffset: 0
          });
        else {
          const a = r.get(l - 1);
          k(
            a !== void 0,
            `Unexpected bounds cache miss for index ${n}`
          ), r.set(l, {
            scrollOffset: a.scrollOffset + a.size,
            size: f
          });
        }
      }
      const i = r.get(n);
      return k(
        i !== void 0,
        `Unexpected bounds cache miss for index ${n}`
      ), i;
    },
    set(n, i) {
      r.set(n, i);
    },
    get size() {
      return r.size;
    }
  };
}
function ze({
  itemCount: e,
  itemProps: t,
  itemSize: s
}) {
  return R(
    () => ye({
      itemCount: e,
      itemProps: t,
      itemSize: s
    }),
    [e, t, s]
  );
}
function Se({
  containerSize: e,
  itemSize: t
}) {
  let s;
  switch (typeof t) {
    case "string": {
      k(
        t.endsWith("%"),
        `Invalid item size: "${t}"; string values must be percentages (e.g. "100%")`
      ), k(
        e !== void 0,
        "Container size must be defined if a percentage item size is specified"
      ), s = e * parseInt(t) / 100;
      break;
    }
    default: {
      s = t;
      break;
    }
  }
  return s;
}
function re({
  containerElement: e,
  containerStyle: t,
  defaultContainerSize: s = 0,
  direction: r,
  isRtl: n = !1,
  itemCount: i,
  itemProps: l,
  itemSize: f,
  onResize: a,
  overscanCount: o
}) {
  const { height: d = s, width: c = s } = we({
    defaultHeight: r === "vertical" ? s : void 0,
    defaultWidth: r === "horizontal" ? s : void 0,
    element: e,
    mode: r === "vertical" ? "only-height" : "only-width",
    style: t
  }), g = P({
    height: 0,
    width: 0
  }), x = r === "vertical" ? d : c, I = Se({ containerSize: x, itemSize: f });
  ie(() => {
    if (typeof a == "function") {
      const p = g.current;
      (p.height !== d || p.width !== c) && (a({ height: d, width: c }, { ...p }), p.height = d, p.width = c);
    }
  }, [d, a, c]);
  const h = ze({
    itemCount: i,
    itemProps: l,
    itemSize: I
  }), z = B(
    (p) => h.get(p),
    [h]
  ), [u, j] = L(
    () => ee({
      cachedBounds: h,
      // TODO Potentially support a defaultScrollOffset prop?
      containerScrollOffset: 0,
      containerSize: x,
      itemCount: i,
      overscanCount: o
    })
  ), {
    startIndexVisible: T,
    startIndexOverscan: E,
    stopIndexVisible: D,
    stopIndexOverscan: v
  } = {
    startIndexVisible: Math.min(i - 1, u.startIndexVisible),
    startIndexOverscan: Math.min(i - 1, u.startIndexOverscan),
    stopIndexVisible: Math.min(i - 1, u.stopIndexVisible),
    stopIndexOverscan: Math.min(i - 1, u.stopIndexOverscan)
  }, U = B(
    () => ue({
      cachedBounds: h,
      itemCount: i,
      itemSize: I
    }),
    [h, i, I]
  ), m = B(
    (p) => {
      const O = C({
        containerElement: e,
        direction: r,
        isRtl: n,
        scrollOffset: p
      });
      return ee({
        cachedBounds: h,
        containerScrollOffset: O,
        containerSize: x,
        itemCount: i,
        overscanCount: o
      });
    },
    [
      h,
      e,
      x,
      r,
      n,
      i,
      o
    ]
  );
  J(() => {
    const p = (r === "vertical" ? e?.scrollTop : e?.scrollLeft) ?? 0;
    j(m(p));
  }, [e, r, m]), J(() => {
    if (!e)
      return;
    const p = () => {
      j((O) => {
        const { scrollLeft: M, scrollTop: S } = e, b = C({
          containerElement: e,
          direction: r,
          isRtl: n,
          scrollOffset: r === "vertical" ? S : M
        }), w = ee({
          cachedBounds: h,
          containerScrollOffset: b,
          containerSize: x,
          itemCount: i,
          overscanCount: o
        });
        return X(w, O) ? O : w;
      });
    };
    return e.addEventListener("scroll", p), () => {
      e.removeEventListener("scroll", p);
    };
  }, [
    h,
    e,
    x,
    r,
    i,
    o
  ]);
  const G = de(
    ({
      align: p = "auto",
      containerScrollOffset: O,
      index: M
    }) => {
      let S = Oe({
        align: p,
        cachedBounds: h,
        containerScrollOffset: O,
        containerSize: x,
        index: M,
        itemCount: i,
        itemSize: I
      });
      if (e) {
        if (S = C({
          containerElement: e,
          direction: r,
          isRtl: n,
          scrollOffset: S
        }), typeof e.scrollTo != "function") {
          const b = m(S);
          X(u, b) || j(b);
        }
        return S;
      }
    }
  );
  return {
    getCellBounds: z,
    getEstimatedSize: U,
    scrollToIndex: G,
    startIndexOverscan: E,
    startIndexVisible: T,
    stopIndexOverscan: v,
    stopIndexVisible: D
  };
}
function he(e) {
  return R(() => e, Object.values(e));
}
function pe(e, t) {
  const {
    ariaAttributes: s,
    style: r,
    ...n
  } = e, {
    ariaAttributes: i,
    style: l,
    ...f
  } = t;
  return X(s, i) && X(r, l) && X(n, f);
}
function Ve({
  cellComponent: e,
  cellProps: t,
  children: s,
  className: r,
  columnCount: n,
  columnKey: i,
  columnWidth: l,
  defaultHeight: f = 0,
  defaultWidth: a = 0,
  dir: o,
  gridRef: d,
  onCellsRendered: c,
  onResize: g,
  overscanCount: x = 3,
  rowCount: I,
  rowHeight: h,
  rowKey: z,
  style: u,
  tagName: j = "div",
  ...T
}) {
  const E = he(t), D = R(
    () => ae(e, pe),
    [e]
  ), [v, U] = L(null), m = Ie(v, o), {
    getCellBounds: G,
    getEstimatedSize: p,
    startIndexOverscan: O,
    startIndexVisible: M,
    scrollToIndex: S,
    stopIndexOverscan: b,
    stopIndexVisible: w
  } = re({
    containerElement: v,
    containerStyle: u,
    defaultContainerSize: a,
    direction: "horizontal",
    isRtl: m,
    itemCount: n,
    itemProps: E,
    itemSize: l,
    onResize: g,
    overscanCount: x
  }), {
    getCellBounds: V,
    getEstimatedSize: _,
    startIndexOverscan: N,
    startIndexVisible: oe,
    scrollToIndex: K,
    stopIndexOverscan: Y,
    stopIndexVisible: le
  } = re({
    containerElement: v,
    containerStyle: u,
    defaultContainerSize: f,
    direction: "vertical",
    itemCount: I,
    itemProps: E,
    itemSize: h,
    onResize: g,
    overscanCount: x
  });
  fe(
    d,
    () => ({
      get element() {
        return v;
      },
      scrollToCell({
        behavior: $ = "auto",
        columnAlign: y = "auto",
        columnIndex: H,
        rowAlign: W = "auto",
        rowIndex: A
      }) {
        const q = S({
          align: y,
          containerScrollOffset: v?.scrollLeft ?? 0,
          index: H
        }), ve = K({
          align: W,
          containerScrollOffset: v?.scrollTop ?? 0,
          index: A
        });
        typeof v?.scrollTo == "function" && v.scrollTo({
          behavior: $,
          left: q,
          top: ve
        });
      },
      scrollToColumn({
        align: $ = "auto",
        behavior: y = "auto",
        index: H
      }) {
        const W = S({
          align: $,
          containerScrollOffset: v?.scrollLeft ?? 0,
          index: H
        });
        typeof v?.scrollTo == "function" && v.scrollTo({
          behavior: y,
          left: W
        });
      },
      scrollToRow({
        align: $ = "auto",
        behavior: y = "auto",
        index: H
      }) {
        const W = K({
          align: $,
          containerScrollOffset: v?.scrollTop ?? 0,
          index: H
        });
        typeof v?.scrollTo == "function" && v.scrollTo({
          behavior: y,
          top: W
        });
      }
    }),
    [v, S, K]
  ), Z(() => {
    O >= 0 && b >= 0 && N >= 0 && Y >= 0 && c && c(
      {
        columnStartIndex: M,
        columnStopIndex: w,
        rowStartIndex: oe,
        rowStopIndex: le
      },
      {
        columnStartIndex: O,
        columnStopIndex: b,
        rowStartIndex: N,
        rowStopIndex: Y
      }
    );
  }, [
    c,
    O,
    M,
    b,
    w,
    N,
    oe,
    Y,
    le
  ]);
  const ge = R(() => {
    const $ = [];
    if (n > 0 && I > 0)
      for (let y = N; y <= Y; y++) {
        const H = V(y), W = [];
        for (let A = O; A <= b; A++) {
          const q = G(A);
          W.push(
            /* @__PURE__ */ Q(
              D,
              {
                ...E,
                ariaAttributes: {
                  "aria-colindex": A + 1,
                  role: "gridcell"
                },
                columnIndex: A,
                key: i ? i({
                  columnIndex: A,
                  data: E,
                  rowIndex: y
                }) : A,
                rowIndex: y,
                style: {
                  position: "absolute",
                  left: m ? void 0 : 0,
                  right: m ? 0 : void 0,
                  transform: `translate(${m ? -q.scrollOffset : q.scrollOffset}px, ${H.scrollOffset}px)`,
                  height: H.size,
                  width: q.size
                }
              }
            )
          );
        }
        $.push(
          /* @__PURE__ */ se(
            "div",
            {
              role: "row",
              "aria-rowindex": y + 1,
              children: W
            },
            z ? z({
              data: E,
              rowIndex: y
            }) : y
          )
        );
      }
    return $;
  }, [
    D,
    E,
    n,
    i,
    O,
    b,
    G,
    V,
    m,
    I,
    z,
    N,
    Y
  ]), xe = /* @__PURE__ */ se(
    "div",
    {
      "aria-hidden": !0,
      style: {
        height: _(),
        width: p(),
        zIndex: -1
      }
    }
  );
  return Q(
    j,
    {
      "aria-colcount": n,
      "aria-rowcount": I,
      role: "grid",
      ...T,
      className: r,
      dir: o,
      ref: U,
      style: {
        position: "relative",
        maxHeight: "100%",
        maxWidth: "100%",
        flexGrow: 1,
        overflow: "auto",
        ...u
      }
    },
    ge,
    s,
    xe
  );
}
const Ae = L, ke = P;
function Te(e) {
  return e != null && typeof e == "object" && "getAverageRowHeight" in e && typeof e.getAverageRowHeight == "function";
}
const ne = "data-react-window-index";
function Le({
  children: e,
  className: t,
  defaultHeight: s = 0,
  listRef: r,
  onResize: n,
  onRowsRendered: i,
  overscanCount: l = 3,
  rowComponent: f,
  rowCount: a,
  rowHeight: o,
  rowKey: d,
  rowProps: c,
  tagName: g = "div",
  style: x,
  ...I
}) {
  const h = he(c), z = R(
    () => ae(f, pe),
    [f]
  ), [u, j] = L(null), T = Te(o), E = R(() => T ? (b) => o.getRowHeight(b) ?? o.getAverageRowHeight() : o, [T, o]), {
    getCellBounds: D,
    getEstimatedSize: v,
    scrollToIndex: U,
    startIndexOverscan: m,
    startIndexVisible: G,
    stopIndexOverscan: p,
    stopIndexVisible: O
  } = re({
    containerElement: u,
    containerStyle: x,
    defaultContainerSize: s,
    direction: "vertical",
    itemCount: a,
    itemProps: h,
    itemSize: E,
    onResize: n,
    overscanCount: l
  });
  fe(
    r,
    () => ({
      get element() {
        return u;
      },
      scrollToRow({
        align: b = "auto",
        behavior: w = "auto",
        index: V
      }) {
        const _ = U({
          align: b,
          containerScrollOffset: u?.scrollTop ?? 0,
          index: V
        });
        typeof u?.scrollTo == "function" && u.scrollTo({
          behavior: w,
          top: _
        });
      }
    }),
    [u, U]
  ), J(() => {
    if (!u)
      return;
    const b = Array.from(u.children).filter((w, V) => {
      if (w.hasAttribute("aria-hidden"))
        return !1;
      const _ = `${m + V}`;
      return w.setAttribute(ne, _), !0;
    });
    if (T)
      return o.observeRowElements(b);
  }, [
    u,
    T,
    o,
    m,
    p
  ]), Z(() => {
    m >= 0 && p >= 0 && i && i(
      {
        startIndex: G,
        stopIndex: O
      },
      {
        startIndex: m,
        stopIndex: p
      }
    );
  }, [
    i,
    m,
    G,
    p,
    O
  ]);
  const M = R(() => {
    const b = [];
    if (a > 0)
      for (let w = m; w <= p; w++) {
        const V = D(w);
        b.push(
          /* @__PURE__ */ Q(
            z,
            {
              ...h,
              ariaAttributes: {
                "aria-posinset": w + 1,
                "aria-setsize": a,
                role: "listitem"
              },
              key: d ? d(w, h) : w,
              index: w,
              style: {
                position: "absolute",
                left: 0,
                transform: `translateY(${V.scrollOffset}px)`,
                // In case of dynamic row heights, don't specify a height style
                // otherwise a default/estimated height would mask the actual height
                height: T ? void 0 : V.size,
                width: "100%"
              }
            }
          )
        );
      }
    return b;
  }, [
    z,
    D,
    T,
    a,
    d,
    h,
    m,
    p
  ]), S = /* @__PURE__ */ se(
    "div",
    {
      "aria-hidden": !0,
      style: {
        height: v(),
        width: "100%",
        zIndex: -1
      }
    }
  );
  return Q(
    g,
    {
      role: "list",
      ...I,
      className: t,
      ref: j,
      style: {
        position: "relative",
        maxHeight: "100%",
        flexGrow: 1,
        overflowY: "auto",
        ...x
      }
    },
    M,
    e,
    S
  );
}
function Me({
  defaultRowHeight: e,
  key: t
}) {
  const [s, r] = L({
    key: t,
    map: /* @__PURE__ */ new Map()
  });
  s.key !== t && r({
    key: t,
    map: /* @__PURE__ */ new Map()
  });
  const { map: n } = s, i = B(() => {
    let c = 0;
    return n.forEach((g) => {
      c += g;
    }), c === 0 ? e : c / n.size;
  }, [e, n]), l = B(
    (c) => {
      const g = n.get(c);
      return g !== void 0 ? g : (n.set(c, e), e);
    },
    [e, n]
  ), f = B((c, g) => {
    r((x) => {
      if (x.map.get(c) === g)
        return x;
      const I = new Map(x.map);
      return I.set(c, g), {
        ...x,
        map: I
      };
    });
  }, []), a = de(
    (c) => {
      c.length !== 0 && c.forEach((g) => {
        const { borderBoxSize: x, target: I } = g, h = I.getAttribute(ne);
        k(
          h !== null,
          `Invalid ${ne} attribute value`
        );
        const z = parseInt(h), { blockSize: u } = x[0];
        u && f(z, u);
      });
    }
  ), [o] = L(() => {
    if (typeof ResizeObserver < "u")
      return new ResizeObserver(a);
  });
  Z(() => {
    if (o)
      return () => {
        o.disconnect();
      };
  }, [o]);
  const d = B(
    (c) => o ? (c.forEach((g) => o.observe(g)), () => {
      c.forEach((g) => o.unobserve(g));
    }) : () => {
    },
    [o]
  );
  return R(
    () => ({
      getAverageRowHeight: i,
      getRowHeight: l,
      setRowHeight: f,
      observeRowElements: d
    }),
    [i, l, f, d]
  );
}
const $e = L, He = P;
let te = -1;
function We(e = !1) {
  if (te === -1 || e) {
    const t = document.createElement("div"), s = t.style;
    s.width = "50px", s.height = "50px", s.overflow = "scroll", document.body.appendChild(t), te = t.offsetWidth - t.clientWidth, document.body.removeChild(t);
  }
  return te;
}
export {
  Ve as Grid,
  Le as List,
  We as getScrollbarSize,
  Me as useDynamicRowHeight,
  Ae as useGridCallbackRef,
  ke as useGridRef,
  $e as useListCallbackRef,
  He as useListRef
};
//# sourceMappingURL=react-window.js.map
